export default __webpack_public_path__ + "static/media/parking.36e36bc6.svg";